
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexBzq4zFq9iqDx2eft9s7gMGXaFJyBSXpifLtN3GYC7OUMeta } from "/home/g/p/vision/pages/index.vue?macro=true";
import { default as _91id_93AcIqJn_45E3D3sXRJFfUG2m9s_hKwTLxWGXxaE63qVpOwMeta } from "/home/g/p/vision/pages/faq/[id].vue?macro=true";
import { default as faqgokWbVAwrapvDNd4UYhDY_45c0AB_WKbuhtTNW6IvhHKUMeta } from "/home/g/p/vision/pages/admin/faq.vue?macro=true";
import { default as _91id_939k4R_45Y82Ew_vK4DhHJhcPh0s0f_45dsjx68T_4VWZz_45qkMeta } from "/home/g/p/vision/pages/blog/[id].vue?macro=true";
import { default as indexutomqEYblnYB4YF5CH9xU97GMsc70I_ISVhVOlE08m8Meta } from "/home/g/p/vision/pages/faq/index.vue?macro=true";
import { default as blogYsjPaGy7N5C1yJc6YEM6DWhhgTIt9rqtWjwj__453uVOkMeta } from "/home/g/p/vision/pages/admin/blog.vue?macro=true";
import { default as index3bfwkNelxeW_45eZ0Q_B0D_45shecU9L6VL7EITz_45bQ7S2kMeta } from "/home/g/p/vision/pages/blog/index.vue?macro=true";
import { default as indexq1N7Up3ZGhYHK0sqLu_HYVQgznQs7Ynq20TwVyPpi00Meta } from "/home/g/p/vision/pages/admin/index.vue?macro=true";
import { default as _91id_93_fXJZkTT3LX4qx06v0RmT6j2e2tGCvxI1uwymiY0wjgMeta } from "/home/g/p/vision/pages/catalog/[id].vue?macro=true";
import { default as indexXFKzLoAXH6CTehWrnsSPnoTPaXJomhC2xGKpEBSCRlAMeta } from "/home/g/p/vision/pages/catalog/index.vue?macro=true";
import { default as indexKmvt2XbDRFN2Irr7Hbz5bM8Z_45ZLk8f797IAoT_5tYJ0Meta } from "/home/g/p/vision/pages/contacts/index.vue?macro=true";
import { default as itemseUSLB0rRv8U4GTFqA1n4Y2I5euGdMKMpR7TKUPdupesMeta } from "/home/g/p/vision/pages/admin/catalog/items.vue?macro=true";
import { default as adminsBvj_fCmGYVqlYoLNLJoN4K7tzR2S7g8pryFUWZK1dw4Meta } from "/home/g/p/vision/pages/admin/catalog/admins.vue?macro=true";
import { default as bunnersEN_tZRAvr34TrhJ05ldsK2dwUGvUe_m6Hs8jBSXVqWsMeta } from "/home/g/p/vision/pages/admin/catalog/bunners.vue?macro=true";
import { default as rewards5b_45uyMnmtHeOWaVIn39Xz2kKh23wGsoABj3gzR2sWqYMeta } from "/home/g/p/vision/pages/admin/catalog/rewards.vue?macro=true";
import { default as indexYXVLBdeLJ0G2gjVggwmVZUT8_Ezm2AL5aysfh88InXAMeta } from "/home/g/p/vision/pages/about-fraudvision/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/g/p/vision/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/home/g/p/vision/pages/index.vue")
  },
  {
    name: "index___ru",
    path: "/ru",
    component: () => import("/home/g/p/vision/pages/index.vue")
  },
  {
    name: "index___cn",
    path: "/cn",
    component: () => import("/home/g/p/vision/pages/index.vue")
  },
  {
    name: "faq-id___en",
    path: "/en/faq/:id()",
    component: () => import("/home/g/p/vision/pages/faq/[id].vue")
  },
  {
    name: "faq-id___ru",
    path: "/ru/faq/:id()",
    component: () => import("/home/g/p/vision/pages/faq/[id].vue")
  },
  {
    name: "faq-id___cn",
    path: "/cn/faq/:id()",
    component: () => import("/home/g/p/vision/pages/faq/[id].vue")
  },
  {
    name: "admin-faq___en",
    path: "/en/admin/faq",
    component: () => import("/home/g/p/vision/pages/admin/faq.vue")
  },
  {
    name: "admin-faq___ru",
    path: "/ru/admin/faq",
    component: () => import("/home/g/p/vision/pages/admin/faq.vue")
  },
  {
    name: "admin-faq___cn",
    path: "/cn/admin/faq",
    component: () => import("/home/g/p/vision/pages/admin/faq.vue")
  },
  {
    name: "blog-id___en",
    path: "/en/blog/:id()",
    component: () => import("/home/g/p/vision/pages/blog/[id].vue")
  },
  {
    name: "blog-id___ru",
    path: "/ru/blog/:id()",
    component: () => import("/home/g/p/vision/pages/blog/[id].vue")
  },
  {
    name: "blog-id___cn",
    path: "/cn/blog/:id()",
    component: () => import("/home/g/p/vision/pages/blog/[id].vue")
  },
  {
    name: "faq___en",
    path: "/en/faq",
    component: () => import("/home/g/p/vision/pages/faq/index.vue")
  },
  {
    name: "faq___ru",
    path: "/ru/faq",
    component: () => import("/home/g/p/vision/pages/faq/index.vue")
  },
  {
    name: "faq___cn",
    path: "/cn/faq",
    component: () => import("/home/g/p/vision/pages/faq/index.vue")
  },
  {
    name: "admin-blog___en",
    path: "/en/admin/blog",
    component: () => import("/home/g/p/vision/pages/admin/blog.vue")
  },
  {
    name: "admin-blog___ru",
    path: "/ru/admin/blog",
    component: () => import("/home/g/p/vision/pages/admin/blog.vue")
  },
  {
    name: "admin-blog___cn",
    path: "/cn/admin/blog",
    component: () => import("/home/g/p/vision/pages/admin/blog.vue")
  },
  {
    name: "blog___en",
    path: "/en/blog",
    component: () => import("/home/g/p/vision/pages/blog/index.vue")
  },
  {
    name: "blog___ru",
    path: "/ru/blog",
    component: () => import("/home/g/p/vision/pages/blog/index.vue")
  },
  {
    name: "blog___cn",
    path: "/cn/blog",
    component: () => import("/home/g/p/vision/pages/blog/index.vue")
  },
  {
    name: "admin___en",
    path: "/en/admin",
    meta: indexq1N7Up3ZGhYHK0sqLu_HYVQgznQs7Ynq20TwVyPpi00Meta || {},
    component: () => import("/home/g/p/vision/pages/admin/index.vue")
  },
  {
    name: "admin___ru",
    path: "/ru/admin",
    meta: indexq1N7Up3ZGhYHK0sqLu_HYVQgznQs7Ynq20TwVyPpi00Meta || {},
    component: () => import("/home/g/p/vision/pages/admin/index.vue")
  },
  {
    name: "admin___cn",
    path: "/cn/admin",
    meta: indexq1N7Up3ZGhYHK0sqLu_HYVQgznQs7Ynq20TwVyPpi00Meta || {},
    component: () => import("/home/g/p/vision/pages/admin/index.vue")
  },
  {
    name: "catalog-id___en",
    path: "/en/catalog/:id()",
    component: () => import("/home/g/p/vision/pages/catalog/[id].vue")
  },
  {
    name: "catalog-id___ru",
    path: "/ru/catalog/:id()",
    component: () => import("/home/g/p/vision/pages/catalog/[id].vue")
  },
  {
    name: "catalog-id___cn",
    path: "/cn/catalog/:id()",
    component: () => import("/home/g/p/vision/pages/catalog/[id].vue")
  },
  {
    name: "catalog___en",
    path: "/en/catalog",
    component: () => import("/home/g/p/vision/pages/catalog/index.vue")
  },
  {
    name: "catalog___ru",
    path: "/ru/catalog",
    component: () => import("/home/g/p/vision/pages/catalog/index.vue")
  },
  {
    name: "catalog___cn",
    path: "/cn/catalog",
    component: () => import("/home/g/p/vision/pages/catalog/index.vue")
  },
  {
    name: "contacts___en",
    path: "/en/contacts",
    component: () => import("/home/g/p/vision/pages/contacts/index.vue")
  },
  {
    name: "contacts___ru",
    path: "/ru/contacts",
    component: () => import("/home/g/p/vision/pages/contacts/index.vue")
  },
  {
    name: "contacts___cn",
    path: "/cn/contacts",
    component: () => import("/home/g/p/vision/pages/contacts/index.vue")
  },
  {
    name: "admin-catalog-items___en",
    path: "/en/admin/catalog/items",
    component: () => import("/home/g/p/vision/pages/admin/catalog/items.vue")
  },
  {
    name: "admin-catalog-items___ru",
    path: "/ru/admin/catalog/items",
    component: () => import("/home/g/p/vision/pages/admin/catalog/items.vue")
  },
  {
    name: "admin-catalog-items___cn",
    path: "/cn/admin/catalog/items",
    component: () => import("/home/g/p/vision/pages/admin/catalog/items.vue")
  },
  {
    name: "admin-catalog-admins___en",
    path: "/en/admin/catalog/admins",
    component: () => import("/home/g/p/vision/pages/admin/catalog/admins.vue")
  },
  {
    name: "admin-catalog-admins___ru",
    path: "/ru/admin/catalog/admins",
    component: () => import("/home/g/p/vision/pages/admin/catalog/admins.vue")
  },
  {
    name: "admin-catalog-admins___cn",
    path: "/cn/admin/catalog/admins",
    component: () => import("/home/g/p/vision/pages/admin/catalog/admins.vue")
  },
  {
    name: "admin-catalog-bunners___en",
    path: "/en/admin/catalog/bunners",
    component: () => import("/home/g/p/vision/pages/admin/catalog/bunners.vue")
  },
  {
    name: "admin-catalog-bunners___ru",
    path: "/ru/admin/catalog/bunners",
    component: () => import("/home/g/p/vision/pages/admin/catalog/bunners.vue")
  },
  {
    name: "admin-catalog-bunners___cn",
    path: "/cn/admin/catalog/bunners",
    component: () => import("/home/g/p/vision/pages/admin/catalog/bunners.vue")
  },
  {
    name: "admin-catalog-rewards___en",
    path: "/en/admin/catalog/rewards",
    component: () => import("/home/g/p/vision/pages/admin/catalog/rewards.vue")
  },
  {
    name: "admin-catalog-rewards___ru",
    path: "/ru/admin/catalog/rewards",
    component: () => import("/home/g/p/vision/pages/admin/catalog/rewards.vue")
  },
  {
    name: "admin-catalog-rewards___cn",
    path: "/cn/admin/catalog/rewards",
    component: () => import("/home/g/p/vision/pages/admin/catalog/rewards.vue")
  },
  {
    name: "about-fraudvision___en",
    path: "/en/about-fraudvision",
    component: () => import("/home/g/p/vision/pages/about-fraudvision/index.vue")
  },
  {
    name: "about-fraudvision___ru",
    path: "/ru/about-fraudvision",
    component: () => import("/home/g/p/vision/pages/about-fraudvision/index.vue")
  },
  {
    name: "about-fraudvision___cn",
    path: "/cn/about-fraudvision",
    component: () => import("/home/g/p/vision/pages/about-fraudvision/index.vue")
  }
]